import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import map from 'lodash/map';
import get from 'lodash/get';
import chunk from 'lodash/chunk';
import KValue from 'components/KJRN/KValue';
import Divider from 'material-ui/Divider';

const HolidayOverview = ({
  overview,
  divider,
}) => {
  const allMonths = [
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
    'January',
    'February',
    'March',
    'April',
  ];
  const chunked = chunk(allMonths, 3);
  const winterAddition = get(overview, 'WinterAddition', 0);
  const winterAdditionFormatted = (winterAddition / divider).toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return (
    <React.Fragment>
      {
        map(chunked, (months, index) => (
          <div
            key={`row-${index}`}
            style={{
              paddingBottom: '16px',
              display: 'flex',
              flexDirection: 'row',
              justifyItems: 'space-between',
              }}
          >
            {map(months, month => (
              <KValue
                key={`month-${month}`}
                value={(get(overview, month, 0) / divider).toLocaleString('de', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                label={
                  <FormattedMessage id={month} />
                }
              />))}
          </div>
        ))
      }
      {winterAddition > 0 && (
      <React.Fragment>
        <Divider style={{ margin: 12 }} />
        <KValue
          key="holiday-winterAddition"
          value={winterAdditionFormatted}
          label={<FormattedMessage id="holidayOverview.winterAddition.title" />}
        />
      </React.Fragment>
      )}
    </React.Fragment>
  );
};

HolidayOverview.propTypes = {
  overview: PropTypes.object.isRequired,
  divider: PropTypes.number.isRequired,
};


export default HolidayOverview;



// WEBPACK FOOTER //
// ./src/components/HolidayOverview.js